"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Chain_1 = tslib_1.__importDefault(require("./Chain"));
const ReportPendingRequests_1 = tslib_1.__importDefault(require("./ReportPendingRequests"));
const LoginInterceptor_1 = tslib_1.__importDefault(require("./LoginInterceptor"));
const HTTPClient_1 = tslib_1.__importDefault(require("./HTTPClient"));
const HTTPError_1 = tslib_1.__importDefault(require("./HTTPError"));
const SharedSecretHandler_1 = tslib_1.__importDefault(require("./SharedSecretHandler"));
const ApiVersionChecker_1 = tslib_1.__importDefault(require("./ApiVersionChecker"));
const __1 = require("..");
class RESTClient {
    constructor({ moduleContext, unmarshaller = str => JSON.parse(str), isSuccessResponse = (response) => response.status >= 200 && response.status < 300, version }) {
        this.unmarshaller = unmarshaller;
        this.isSuccessResponse = isSuccessResponse;
        this.moduleContext = moduleContext;
        this.defaultChain = [
            new ApiVersionChecker_1.default(version),
            new ReportPendingRequests_1.default(),
            new LoginInterceptor_1.default(),
            new SharedSecretHandler_1.default(),
            new HTTPClient_1.default()
        ];
    }
    get(url, description, headers, chain) {
        return this.send(url, "GET", undefined, description, headers, chain);
    }
    post(url, body, description, headers, chain) {
        return this.send(url, "POST", body, description, headers, chain);
    }
    put(url, body, description, headers, chain) {
        return this.send(url, "PUT", body, description, headers, chain);
    }
    delete(url, body, description, headers, chain) {
        return this.send(url, "DELETE", body, description, headers, chain);
    }
    send(url, method, body, description, customHeaders = RESTClient.defaultHeaders, chain = this.defaultChain) {
        // create a copy to make sure that global headers aren't modified
        const globalHeaders = Object.assign({}, this.moduleContext?.getHTTPSessionHeaders() ?? {});
        if (globalHeaders["procuration-identifier"]) {
            const audiences = this.moduleContext?.getAudiences?.().join(",");
            if (audiences) {
                globalHeaders["procuration-audience"] = audiences;
            }
        }
        const headers = Object.assign({}, globalHeaders, customHeaders);
        const request = {
            body,
            description,
            headers,
            method,
            url
        };
        return new Promise((resolve, reject) => {
            new Chain_1.default(chain, (req) => {
                const response = req.response;
                if (response) {
                    if (this.isSuccessResponse(response)) {
                        let responseValue;
                        const rawResponse = response.responseText || response.response;
                        if (rawResponse) {
                            try {
                                responseValue = this.unmarshaller(rawResponse);
                                resolve(responseValue);
                            }
                            catch (e) {
                                reject(new Error("Problem unmarshalling response: " + e.message));
                            }
                        }
                        else {
                            resolve(undefined);
                        }
                    }
                    else {
                        let responseContent = response.responseText || response.response;
                        const xSupportTag = response.headers.getHeader(__1.CommonConstants.X_SUPPORT_TAG_HEADER);
                        if (responseContent instanceof Blob) {
                            // Extract blob content asynchronously so that caller doesn't have to worry about this
                            responseContent.text().then(v => {
                                reject(new HTTPError_1.default(v, response.status, response.statusText || "Det fejlede at sende beskeden", url, xSupportTag));
                            });
                        }
                        else {
                            if (!response.response && response.status === 0) {
                                // Request never reached a server
                                responseContent = "Det fejlede at sende beskeden";
                            }
                            reject(new HTTPError_1.default(responseContent, response.status, response.statusText || "Det fejlede at sende beskeden", url, xSupportTag));
                        }
                    }
                }
            }).send(request);
        });
    }
}
RESTClient.defaultHeaders = {
    "Accept": "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8"
};
exports.default = RESTClient;
//# sourceMappingURL=RESTClient.js.map